const learningContent = [
    {
        href:'https://learning.emofid.com/what-is-the-bourse-view/',
        title: {fa:'بورس ویو چیست و چه امکاناتی دارد؟', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d8%af%d8%b1%db%8c%d8%a7%d9%81%d8%aa-%d8%a7%d8%b4%d8%aa%d8%b1%d8%a7%da%a9-%d8%a8%d9%88%d8%b1%d8%b3%e2%80%8c%d9%88%db%8c%d9%88/',
        title: {fa:'نحوه دریافت اشتراک بورس‌ ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%86%d8%ad%d9%88%d9%87-%d9%88%d8%b1%d9%88%d8%af-%d8%a8%d9%87-%d8%a8%d9%88%d8%b1%d8%b3%e2%80%8c%d9%88%db%8c%d9%88/',
        title: {fa:'نحوه ورود به بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%86%da%af%d8%a7%d9%87%db%8c-%d8%a8%d9%87-%d8%a8%d8%b1%d8%ae%db%8c-%da%a9%d8%a7%d8%b1%d8%a8%d8%b1%d8%af%d9%87%d8%a7%db%8c-%d8%ac%d8%b0%d8%a7%d8%a8-%d8%a8%d9%88%d8%b1%d8%b3%e2%80%8c-%d9%88%db%8c/',
        title: {fa:'بررسی ساده اطلاعات بازار در بورس‌ ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d8%ac%d8%b3%d8%aa%e2%80%8c%d9%88%d8%ac%d9%88%db%8c-%d8%b3%d9%87%d9%85-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c%d9%88/',
        title: {fa:'جستجو سهم در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d8%aa%d8%b1%d8%a7%d8%b2%d9%86%d8%a7%d9%85%d9%87-%d8%b4%d8%b1%da%a9%d8%aa-%d9%88-%d8%a7%d8%b7%d9%84%d8%a7%d8%b9%d8%a7%d8%aa-%d8%a2%d9%86-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c%d9%88/',
        title: {fa:'ترازنامه شرکت و اطلاعات آن در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d8%a8%d8%b1%d8%b1%d8%b3%db%8c-%d8%a7%d8%b7%d9%84%d8%a7%d8%b9%d8%a7%d8%aa-%d8%b3%d9%88%d8%af-%d9%88-%d8%b2%db%8c%d8%a7%d9%86-%d8%b4%d8%b1%da%a9%d8%aa-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c/',
        title: {fa:'بررسی اطلاعات سود و زیان شرکت در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/cash-flow-statement-at-bourse-view/',
        title: {fa:'صورت جریان وجوه نقد در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/bourse-view-in-one-look-introduction/',
        title: {fa:'معرفی سهم در یک نگاه در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/financial-ratios-at-bourse-view/',
        title: {fa:'معرفی بخش نسبت های مالی در سامانه بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/bourseview-fundamental-graph-analysis/',
        title: {fa:'بررسی نمودار بنیادی در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/price-history-at-bourse-view/',
        title: {fa:'تاریخچه قیمت سهم شرکت‌ها در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/natural-and-legal-page-in-bourseview/',
        title: {fa:'بررسی اطلاعات حقیقی و حقوقی در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d8%a8%d8%b1%d8%b1%d8%b3%db%8c-%d8%a7%d8%b7%d9%84%d8%a7%d8%b9%db%8c%d9%87%e2%80%8c%d9%87%d8%a7%db%8c-%d8%b3%d9%87%d9%85-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c%d9%88/',
        title: {fa:'بررسی اطلاعیه‌های سهم در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%85%d8%b9%d8%b1%d9%81%db%8c-%d8%a8%d8%ae%d8%b4-%d8%af%d8%b1%d8%a8%d8%a7%d8%b1%d9%87-%d8%b4%d8%b1%da%a9%d8%aa-%d8%af%d8%b1-%d8%b3%d8%a7%d9%85%d8%a7%d9%86%d9%87-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c/',
        title: {fa:'معرفی بخش درباره شرکت در سامانه بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%85%d8%b9%d8%b1%d9%81%db%8c-%d8%a8%d8%ae%d8%b4-%d9%be%d8%b1%d8%aa%d9%81%d9%88%d9%84%db%8c%d9%88-%d8%af%d8%b1-%d8%b3%d8%a7%d9%85%d8%a7%d9%86%d9%87-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c%d9%88/',
        title: {fa:'معرفی بخش پرتفولیو در سامانه بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%85%d8%b9%d8%b1%d9%81%db%8c-%d8%a8%d8%ae%d8%b4-%d8%aa%d9%88%d9%84%db%8c%d8%af-%d9%88-%d9%81%d8%b1%d9%88%d8%b4-%d8%af%d8%b1-%d8%b3%d8%a7%d9%85%d8%a7%d9%86%d9%87-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c/',
        title: {fa:'معرفی بخش تولید و فروش', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%85%d8%b9%d8%b1%d9%81%db%8c-%d8%a8%d8%ae%d8%b4-%d8%a7%d8%b7%d9%84%d8%a7%d8%b9%d8%a7%d8%aa-%da%af%d8%b1%d8%af%d8%b4-%d9%85%d9%88%d8%ac%d9%88%d8%af%db%8c-%da%a9%d8%a7%d9%84%d8%a7-%d8%af%d8%b1-%d8%a8/',
        title: {fa:'معرفی بخش اطلاعات گردش موجودی کالا', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%85%d8%b9%d8%b1%d9%81%db%8c-%d8%a8%d8%ae%d8%b4-%d8%a7%d8%b7%d9%84%d8%a7%d8%b9%d8%a7%d8%aa-%d8%a8%d9%87%d8%a7%db%8c-%d8%aa%d9%85%d8%a7%d9%85-%d8%b4%d8%af%d9%87-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3/',
        title: {fa:'معرفی بخش اطلاعات بهای تمام شده', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d8%a8%d8%b1%d8%b1%d8%b3%db%8c-%d8%a7%d8%b7%d9%84%d8%a7%d8%b9%d8%a7%d8%aa-%d9%87%d8%b2%db%8c%d9%86%d9%87%e2%80%8c%d9%87%d8%a7%db%8c-%d8%a7%d8%af%d8%a7%d8%b1%db%8c-%d9%88-%d8%b9%d9%85%d9%88%d9%85%db%8c/',
        title: {fa:'بررسی اطلاعات هزینه‌های اداری و عمومی', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d8%b3%d8%a7%db%8c%d8%b1-%d8%af%d8%b1%d8%a2%d9%85%d8%af%d9%87%d8%a7-%d8%b4%d8%b1%da%a9%d8%aa-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c%d9%88/',
        title: {fa:'سایر درآمدهای شرکت در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%88%d8%b6%d8%b9%db%8c%d8%aa-%d8%a7%d8%b1%d8%b2%db%8c-%d9%88-%d8%aa%d8%b3%d9%87%db%8c%d9%84%d8%a7%d8%aa-%d8%b4%d8%b1%da%a9%d8%aa%e2%80%8c%d9%87%d8%a7-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88/',
        title: {fa:'وضعیت ارزی و تسهیلات شرکت‌ها در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%85%d8%b9%d8%b1%d9%81%db%8c-%d8%b5%d9%81%d8%ad%d9%87-%d8%b5%d9%86%d8%a7%db%8c%d8%b9-%d8%af%d8%b1-%d8%b3%d8%a7%d9%85%d8%a7%d9%86%d9%87-%d8%a8%d9%88%d8%b1%d8%b3%e2%80%8c%d9%88%db%8c%d9%88/',
        title: {fa:'معرفی صفحه صنایع در سامانه بورس‌ ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/screener-page-of-bourse-view/',
        title: {fa:'معرفی غربالگر و امکانات آن در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/market-watch-in-bourse-view/',
        title: {fa:'معرفی نقشه بازار در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d9%85%d8%b9%d8%b1%d9%81%db%8c-%d8%a8%d8%ae%d8%b4-%d8%a7%d9%88%d8%b1%d8%a7%d9%82-%d8%a8%d8%a7-%d8%af%d8%b1%d8%a2%d9%85%d8%af-%d8%ab%d8%a7%d8%a8%d8%aa-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c/',
        title: {fa:'معرفی بخش اوراق با درآمد ثابت در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/announcements-of-listed-companies/',
        title: {fa:'معرفی صفحه اطلاعیه ها و مجامع در بورس ویو', en:''} ,
        
    },
    {
        href:'https://learning.emofid.com/%d8%af%d8%a7%d8%af%d9%87-%d9%87%d8%a7%db%8c-%da%a9%d9%84%d8%a7%d9%86-%d8%af%d8%b1-%d8%a8%d9%88%d8%b1%d8%b3-%d9%88%db%8c%d9%88/',
        title: {fa:'داده های کلان در بورس‌ ویو', en:''} ,
        
    }
]


export default learningContent;